exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\n  min-height: 35px;\n  min-width: 80px; }\n\n.fixed {\n  height: 215px; }\n\ninput {\n  min-width: 80px; }\n", ""]);

// exports
